import React from 'react';

class ImgCheckCircleFilled extends React.Component {
	render() {
		return (
			<div className={"ImgCheckCircleFilled " + this.props.className }>
			<svg
			  viewBox="0 0 16 16"
			  xmlns="http://www.w3.org/2000/svg">
			  <path
			  d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm2.432-11.869l-3.176 5.68-2.513-2.547-1.139 1.124 4.01 4.062 4.215-7.538-1.397-.78z"
			  />
			  <use fillRule="evenodd"
			/>
			</svg>
			</div>

		)
	}
}

export default ImgCheckCircleFilled;



// WEBPACK FOOTER //
// ./src/components/atomic/atoms/ImgCheckCircleFilled/ImgCheckCircleFilled.js